import React from 'react';
import { Card } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

function FormMainpage() {
  const history = useNavigate();
  const {
    userStore: { InstantpageRedirectoption },
  } = useStore();
  const routingCard = () => {
    InstantpageRedirectoption();
    history('/dashboard');
  };

  // if (instantpageRedirectPage) {
  //   return history('/dashboard');
  // }
  return (
    <div className="FormMainpage-Container">
      <Card.Group style={{ height: '550px' }}>
        <Card className="FormMainpage-Container-card" onClick={routingCard}>
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'rgba(0,0,0,.85);' }}>
              Vault Management System Templates - 1
            </Card.Header>
            <br />
            <span>
              <img src="/assets/Home.png" alt="" width="300" height="180px" />
            </span>
          </Card.Content>
        </Card>
        <Card className="FormMainpage-Container-card">
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'black', opacity: '0.3' }}>
              Vault Management System Templates - 2
            </Card.Header>
            <br />
            <span>
              <img
                src="/assets/Home.png"
                alt=""
                width="300"
                height="180px"
                style={{ opacity: '0.3' }}
              />
            </span>
          </Card.Content>
        </Card>
        <Card className="FormMainpage-Container-card">
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'black', opacity: '0.3' }}>
              Vault Management System Templates - 3
            </Card.Header>
            <br />
            <span>
              <img
                src="/assets/Home.png"
                alt=""
                width="300"
                height="180px"
                style={{ opacity: '0.3' }}
              />
            </span>
          </Card.Content>
        </Card>
        <Card className="FormMainpage-Container-card">
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'black', opacity: '0.3' }}>
              Vault Management System Templates - 4
            </Card.Header>
            <br />
            <span>
              <img
                src="/assets/Home.png"
                alt=""
                width="300"
                height="180px"
                style={{ opacity: '0.3' }}
              />
            </span>
          </Card.Content>
        </Card>
        <Card className="FormMainpage-Container-card">
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'black', opacity: '0.3' }}>
              {' '}
              Vault Management System Templates - 5
            </Card.Header>
            <br />
            <span>
              <img
                src="/assets/Home.png"
                alt=""
                width="300"
                height="180px"
                style={{ opacity: '0.3' }}
              />
            </span>
          </Card.Content>
        </Card>
        <Card className="FormMainpage-Container-card">
          <Card.Content>
            <br />
            <Card.Header style={{ color: 'black', opacity: '0.3' }}>
              Vault Management System Templates - 6
            </Card.Header>
            <br />
            <span>
              <img
                src="/assets/Home.png"
                alt=""
                width="300"
                height="180px"
                style={{ opacity: '0.3' }}
              />
            </span>
          </Card.Content>
        </Card>
      </Card.Group>
    </div>
  );
}
export default observer(FormMainpage);
